import React, { useEffect, useState } from "react";
import rightArrow from "../../assets/images/icons/rightArrow.png";
import { Link, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";
import qs from "qs";
import { Badge, Button, Col, Dropdown, Row } from "react-bootstrap";
import Filter from "../../components/Filter";
import Constants from "../Variables/Constants";
import axios from "axios";
import Product from "./Product";
import NoData from "../../components/NoData";

const FavProducts = () => {
  const location = useLocation();
  const path = location.pathname.substring(1).toUpperCase();
  const [productList, setProductList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchPayload, setSearchPayload] = useState({
    search: "",
    sortBy: "",
    startDate: "",
    endDate: "",
  });

  const getAllProducts = () => {
    const payload = {
      page: currentPage,
      limit: 20,
      is_favourite: "yes",
      ...searchPayload,
    };
    try {
      axios
        .get(`${Constants.getUrls.getAllProducts}?${qs.stringify(payload)}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            const data = resp.data.data.docs;
            if (data && Array.isArray(data) && data.length > 0) {
              setProductList(resp.data.data.docs);
            } else {
              setProductList([]);
            }
            setTotalPages(resp?.data?.data?.totalPages);
          }
        })
        .catch((error) => {
          console.error("Error in stylesChange:", error);
        });
    } catch (error) {
      console.error("Error in getAllProducts:", error);
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1); // Update the current page
  };

  useEffect(() => {
    getAllProducts();
  }, [flag, searchPayload, currentPage]);

  return (
    <>
      <section className="mt-3">
        <div className="container-fluid px-5">
          <div className="d-flex justify-content-between align-items-center">
            <nav className="my-5 font-poppins route-navigation">
              <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
                {" "}
                <li className="list-unstyled">
                  <Link to={"/"}>HOME </Link>
                </li>
                <li className="list-unstyled">
                  <img loading="lazy"  src={rightArrow} alt="" />
                </li>
                <li className="list-unstyled text-dark">{path}</li>
              </ul>
            </nav>
            <Filter
              searchPayload={searchPayload}
              setSearchPayload={setSearchPayload}
            />
          </div>
          {productList.length === 0 && (
            <NoData image={"/noFav.png"} text={"No Favorite Products Yet!"} />
          )}
          <Row className="g-4 mt-5">
            {productList.map((product, index) => (
              <Col sm="6" lg="3" key={index}>
                <Product
                  product={product}
                  flag={flag}
                  setFlag={setFlag}
                  categoryId={product?.category?._id}
                  collectionId={product?.sub_category?._id}
                />
              </Col>
            ))}
          </Row>
          {productList.length > 0 && (
            <Row>
              <Col md={12} className="d-flex fs-18 justify-content-center">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={totalPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </Col>
            </Row>
          )}
        </div>
      </section>
    </>
  );
};

export default FavProducts;
